import { useCompanyProfile } from '../../../hooks/useCompanyProfile';
import { useRetrieveCompanyItemCategories } from '../../../hooks/useRetrieveCompanyItemCategories';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { useVariantEnabled, Variant } from '../../../lib/experiment';

export const useNavbarRewards = () => {
	const { user } = useUserProfile();
	const { company } = useCompanyProfile();

	const isHideRewardsEnabled = useVariantEnabled(Variant.HideRewards);

	const enabled = isHideRewardsEnabled && !!user && !!company;

	const { data: companyCategories, isError, isLoading: loadingCompanyCategories } = useRetrieveCompanyItemCategories(enabled);

	if (isError) {
		return {
			companyCategories: [],
			isError,
			loadingCompanyCategories: false,
			showRewardsNavigation: true,
		};
	}

	if (!isHideRewardsEnabled) {
		return {
			companyCategories,
			loadingCompanyCategories: false,
			showRewardsNavigation: true,
		};
	}

	const showRewardsNavigation = !!(companyCategories && companyCategories.length > 0);

	return {
		companyCategories,
		loadingCompanyCategories,
		showRewardsNavigation,
	};
};
